import { atom } from 'recoil';
import { ApiClient } from '../../@sprinx/react-after-razzle';
import { GlobalStateRegister } from '../../@sprinx/react-after-razzle/stateStore';

export type GiftProducts = {
  id: number;
  imageSrc: string;
  name: string;
  pointsToSpend: number;
};

export function getGiftProducts(apiClient: ApiClient): Promise<GiftProducts[]> {
  return apiClient.get('/v1/giftProducts/list');
}

export const giftProductsState = GlobalStateRegister.register(
  atom<GiftProducts[] | []>({
    key: 'giftProducts',
    default: [],
  }),
);

export const shoppingSelectedGiftProductsState = GlobalStateRegister.register(
  atom<GiftProducts | undefined>({
    key: 'shoppingSelectedGiftProduct',
    default: undefined,
  }),
);

export const shoppingCartGainUserPointsState = GlobalStateRegister.register(
  atom<number>({
    key: 'shoppingCartGainUserPoints',
    default: 0,
  }),
);
